import ResponsiveContent from "@/elements/components/shared/responsive-content";
import UserPersonaOptions from "@/elements/components/shared/user-persona-options";
import { useRouter } from "expo-router";
import React from "react";
import { View, Text, ScrollView, Image, Linking } from "react-native";

function SignInOptionsScreen() {
  const router = useRouter();

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <ScrollView className="py-safe">
        <View className="h-[78]" />
        <View className="items-center mb-8">
          <Image
            source={require("@/assets/images/logo_text.png")}
            style={{ width: 200, height: 60 }}
            resizeMode="contain"
          />
        </View>
        <View className="gap-1 mx-5">
          <Text className="font-zilla-slab-medium leading-[1.2] font-medium text-[28px] text-black text-center">
            Sign in to your account
          </Text>
          <Text className="font-geologica-regular font-normal text-[20px] text-black leading-[1.5] text-center">
            Pick the option that best describes you.
          </Text>
        </View>
        <View className="h-8" />
        <ResponsiveContent>
          <View className="mx-5 gap-8">
            <View className="mx-[72px] gap-8">
              <UserPersonaOptions />
            </View>

            <View className="h-[1px] bg-[#81858A20] mx-[54px]" />

            <Text
              onPress={() => {
                router.replace("/(auth)/sign-up-options");
              }}
              className="px-[2] text-center font-geologica-medium font-medium text-[18px] text-teal-600 leading-6"
            >
              I want to create an account
            </Text>
          </View>
        </ResponsiveContent>
        <View className="h-8" />
        <View className="items-center pb-8">
          <Text
            onPress={() => {
              Linking.openURL("https://www.loopedinlearning.io");
            }}
            className="text-center font-geologica-medium font-medium text-[16px] text-teal-600"
          >
            www.loopedinlearning.io
          </Text>
        </View>
      </ScrollView>
    </View>
  );
}

export default SignInOptionsScreen;
